import { Box, Grid, Paper, withStyles } from '@material-ui/core';
import TablePagination from '@mui/material/TablePagination';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React, { useMemo, useState } from 'react';
import TableComponent from '../../../../../common/components/Table';
import ColumnConfig from '../../../../../common/config/ColumnConfig';
import * as constants from '../../../../../common/constants';
import ExportToCSV from '../../../common/components/ExportToCSV';
import ChannelsListing from './ChannelsListing';

const styles = () => ({
  root: {
    width: '100%'
  },
  columnStyle: {
    fontFamily: 'Open Sans, Calibri, Tahoma, sans-serif !important',
    fontWeight: '600 !important',
    fontSize: '14px !important'
  },
  radioButton: {
    textAlign: 'center'
  },
  tableText: {
    textAlign: 'center',
    color: '#6a7070',
    fontSize: '14px !important'
  },
  tableDateWidth: {
    width: '110px'
  },
  tableBookWidth: {
    width: '120px'
  },
  tableTitleWidth: {
    width: '120px'
  },
  tableLinkWidth: {
    width: '80px'
  },
  tableFilterTextWidth: {
    width: '150px'
  },
  tableFilterLikeWidth: {
    width: '145px'
  },
  tableCommentsWidth: {
    width: '160px'
  },
  tableUnansWidth: {
    width: '185px'
  },
  tableTrendsWidth: {
    width: '185px'
  },
  tableQuizWidth: {
    width: '185px'
  },
  tableSummaryWidth: {
    width: '180px'
  },
  tableExplainWidth: {
    width: '165px'
  },
  dateRange: {
    display: 'flex',
    padding: '10px',
    justifyContent: 'center',
    fontWeight: '600'
  },
  tableLeftScroll: {
    maxHeight: '500px',
    overflow: 'hidden',
    overflowY: 'scroll',
    borderRadius: '2px',
    border: '1px solid #0003'
  }
});

const ChannelsTrendsGrid = ({
  channelsUtilityTrendsData,
  channelsListingUtilityData,
  selectListingOption,
  classes,
  selectRadioOption,
  sorting,
  setOrder,
  setDirectionValue,
  startDate,
  endDate,
  tenantId,
  channelsList
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const startDateVal = startDate
    ? moment(startDate).format(constants.MM_DD_YYYY_FORMAT)
    : moment(new Date()).format(constants.MM_DD_YYYY_FORMAT);
  const endDateVal = endDate
    ? moment(endDate).format(constants.MM_DD_YYYY_FORMAT)
    : moment(new Date()).format(constants.MM_DD_YYYY_FORMAT);
  const channelsCountHeaders = [
    {
      key: 'date',
      name: 'Date Range'
    },
    {
      key: 'channelsId',
      name: constants.CHANNELS_ID
    },
    {
      key: 'videoSummaryCount',
      name: constants.GENERATE_VIDEO_SUMMARY_COUNT
    },
    {
      key: 'likeCount',
      name: constants.GPT_TRENDS_LIKECOUNT,
      columnWidth: '100px'
    },
    {
      key: 'disLikeCount',
      name: constants.GPT_TRENDS_DISLIKECOUNT,
      columnWidth: '100px'
    },
    {
      key: 'questionIntentCount',
      name: constants.GENERATE_QUESTION_INTENT_COUNT
    }
    // {
    //   key: 'questionSolutionCount',
    //   name: constants.GENERATE_QUESTION_SOLUTION_COUNT
    // },
    // {
    //   key: 'questionStepsSolutionCount',
    //   name: constants.QUESTION_STEP_SOLUTION_COUNT
    // }
  ];

  // Convert the accumulator object back to an array
  const aggregatedChannelsUtilityTrendsData = selectRadioOption ? channelsUtilityTrendsData : [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const setFromToValueForPagination = (from, to, count) => {
    return `${from}-${to} of ${count}`;
  };

  const onColumnClick = (val) => {
    sorting(val);
  };
  const fileName = `channels_count_${new Date().getTime()}`;
  return (
    <>
      {selectRadioOption && (
        <>
          <ExportToCSV headers={channelsCountHeaders} data={aggregatedChannelsUtilityTrendsData} fileTitle={fileName} />
          <Paper sx={{ p: 2 }} className={classes.tableLeftScroll}>
            <div className={classes.dateRange}>
              Date Range: {startDateVal} - {endDateVal}
            </div>
            <TableComponent
              columns={ColumnConfig.ChannelsTrendsDataGridColumn}
              data={
                aggregatedChannelsUtilityTrendsData &&
                Array.isArray(aggregatedChannelsUtilityTrendsData) &&
                aggregatedChannelsUtilityTrendsData.length > 0 &&
                aggregatedChannelsUtilityTrendsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              }
              onColumnClick={onColumnClick}
              order={setOrder}
              onRowClick={() => {}}
              directionValue={setDirectionValue}
              userEmailDetails={{}}
              onMouseEnter={() => {}}
              showSelectColumn
            />
            <TablePagination
              component="div"
              count={aggregatedChannelsUtilityTrendsData.length}
              labelDisplayedRows={({ from, to, count }) =>
                useMemo(() => setFromToValueForPagination(from, to, count), [from, to, count])
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ display: 'flex', justifyContent: 'center' }}
            />
          </Paper>
        </>
      )}
      {selectListingOption && (
        <Paper>
          <Grid item xs={12}>
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', p: '0px 33px' }}>
              <br />
              <ChannelsListing
                channelsListingUtilityData={channelsListingUtilityData}
                startDate={startDate}
                endDate={endDate}
                tenantId={tenantId}
                channelsList={channelsList}
              />
            </Box>
          </Grid>
        </Paper>
      )}
    </>
  );
};

ChannelsTrendsGrid.propTypes = {
  classes: PropTypes.object.isRequired,
  channelsListingUtilityData: PropTypes.array.isRequired,
  channelsUtilityTrendsData: PropTypes.array.isRequired,
  selectListingOption: PropTypes.string.isRequired,
  sorting: PropTypes.func.isRequired,
  setDirectionValue: PropTypes.string.isRequired,
  selectRadioOption: PropTypes.string.isRequired,
  setOrder: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  tenantId: PropTypes.string.isRequired,
  channelsList: PropTypes.array.isRequired
};

export default withStyles(styles)(ChannelsTrendsGrid);
